import { render, staticRenderFns } from "./ActionsModal.vue?vue&type=template&id=10c02c9c"
import script from "./ActionsModal.vue?vue&type=script&lang=ts"
export * from "./ActionsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports